import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=28d03885"
import script from "./TipTap.vue?vue&type=script&lang=ts"
export * from "./TipTap.vue?vue&type=script&lang=ts"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=28d03885&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports